import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdiomasService {

  idEmpresa: string;
  idUsuario: string;
  idInstituto: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){

    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  //SERVICIOS CERTIFICAR
  getStatusIdioma(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	idiomas: 1};
    console.log(this.idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusIdioma(datos){
    this.obtienInfo();
    // let datos: any = {fechaCertificar: anio,	idiomas: 3};
    console.log(datos);

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  reiniciarProceso(datos){
    this.obtienInfo();
    // let datos: any = {fechaCertificar: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.reiniciarCertificar + this.idEmpresa, datos);
  }

  reiniciarProcesoFocus(idEncuesta){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.reiniciarFocus + idEncuesta, null);
  }

  reiniciarProcesoMedir(productoId: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.reiniciarMedir + productoId, null);
  }

  reiniciarProcesoPulse(productoId: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.reiniciarPulse + this.idEmpresa+'/'+productoId, null);
  }

  getListaIdiomas(datos: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getListaIdiomas + this.idEmpresa, datos);//id plantilla fecha certif
  }

  getIdiomas(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.idiomasGuardados + this.idEmpresa);
  }

  guardaIdioma(idioma:backInter.nuevoIdioma){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.idiomasGuardados + this.idEmpresa, idioma);
  }

  borraIdioma(idIdioma:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.borrarIdioma + this.idEmpresa, idIdioma);
  }

  // NUEVOS SERVICES PARA IDIOMAS
  getIdiomasProd(fecha: backInter.getIdiomaFechas){
    this.obtienInfo();
    console.log("Fecha ",fecha);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + this.idEmpresa, fecha);
  }

  guardaIdiomaProd(idioma:backInter.nuevoIdioma){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.idiomasGuardados + this.idEmpresa, idioma);
  }

  //SERVICIOS MEDIR
  getStatusIdiomaMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusIdiomaMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	idiomas: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  getIdiomasProdMedir(fecha: backInter.getIdiomaFechas){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getIdiomasGuardados + this.idEmpresa, fecha);
  }

  getListaIdiomasMedir(datos: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getListaIdiomas + this.idEmpresa, datos);//id plantilla fecha certif
  }

  //Servicios  PulseCheck
  getListaIdiomasPulse(datos: any){
    this.obtienInfo();
    console.log("entro el servioczfd");
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getListaIdiomas + this.idEmpresa, datos);//id plantilla fecha certif
  }
  getIdiomasProdPulse(fecha: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getIdiomasGuardados + this.idEmpresa, fecha);
  }

  getStatusIdiomaPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getStatusPart+ this.idEmpresa, datos);
  }

  guardaStatusIdiomaPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	idiomas: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
  }


  ///servicios Focus FocusArea
  getStatusIdiomaFocus(anio: any){
    this.obtienInfo();
    let datos: any = {encuestaID: anio,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusIdiomaFocus(anio: any){
    this.obtienInfo();
    let datos: any = {encuestaID: anio,	idiomas: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
  }

  getIdiomasPlantillas(data:any){
    this.obtienInfo();
    let datos :any={empresaId:this.idEmpresa, plantillaId:data}
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getIdiomasPlantilla ,datos);
  }
  getListaIdiomasFocus(){
    this.obtienInfo();
    let datos :any={empresaId:this.idEmpresa}
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getListaIdiomasFocus + localStorage.getItem('encuestaID'),datos);//id plantilla fecha certif
  }

  guardaIdiomasEncuestaFocus(clave:any,tipo:any){
    this.obtienInfo();
    let agregar: any = { tipoIdioma:tipo, clave:clave,empresaId:this.idEmpresa};
    console.log(agregar);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.saveIdeomasFocus +localStorage.getItem('encuestaID'), agregar);
  }

  deleteIdiomasPlantillas(data:any){
    this.obtienInfo();
    let datos :any={empresaId:this.idEmpresa,idiomaId:data}
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.deleteIdiomasFocus + localStorage.getItem('encuestaID'),datos);
  }

  getIdiomasCertificar(fecha: backInter.getIdiomaFechas,idEmpresa){
    this.obtienInfo();
    //console.log("Fecha "+fecha);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + idEmpresa, fecha);
  }

  getListaIdiomasCer(datos: any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getListaIdiomas + idEmpresa, datos);//id plantilla fecha certif
  }
  getListaIdiomasMedir_Detailt(datos: any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getListaIdiomas + idEmpresa, datos);//id plantilla fecha certif
  }

  getListaIdiomasPulse_detail(datos: any,idEmpresa){

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getListaIdiomas + idEmpresa, datos);//id plantilla fecha certif
  }

  getListaIdiomasMedir_Generico(datos: any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getListaIdiomas + idEmpresa, datos);//id plantilla fecha certif
  }
  // Nueva prueba

  getIdiomasProd_Detail(fecha: backInter.getIdiomaFechas,idEmpresa){
    //console.log("Fecha "+fecha);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + idEmpresa, fecha);
  }
  getIdiomasProdMedir_Detail(fecha: backInter.getIdiomaFechas,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getIdiomasGuardados + idEmpresa, fecha);
  }

  getIdiomasProdPulse_Detail(fecha: any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getIdiomasGuardados + idEmpresa, fecha);
  }

  ////////// SERVICIOS CAT MASTER
  actualizaIdiomasCuestionario(surveyProductId:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.actualizaIdiomasCuestionario + surveyProductId, {});
  }
  getSeccionesCuestionario(surveyProductId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getSeccionesCuestionario + surveyProductId);
  }
  saveJsonsProducto(){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.saveJsons + this.idEmpresa, {productoId:localStorage.getItem('productoID')});
  }

  getNivelNotificacionCatServ(instituto:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getNivelNotificacionCat + instituto);
  }
}
